import styled, { css } from 'styled-components'
import { AdvantagesElement } from 'Pages/landings/newLandings/common/components'
import {
	themeObject,
	textModels,
	WrapperBlock,
	gridThree,
	media,
	Breakpoints,
	Tab,
	container,
} from 'Pages/landings/newLandings/common/style'

export const Control = styled.div`
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	gap: 12px;
	padding: 0 24px;
	${textModels('notAdaptive', 'm', '600')}
	color: ${themeObject.colors.grey[800]};
	${media('gap: initial; padding: initial;', Breakpoints.ms)};
`

export const ListWrapper = styled.div<{ tabActive: boolean }>`
	${container};
	${({ tabActive }) =>
		tabActive &&
		css`
			display: none;
		`}
`
export const List = styled(WrapperBlock)`
	${gridThree};
	column-gap: 32px;
	${media('grid: initial', Breakpoints.sm)};
	${media('grid: 1fr / repeat(3, 1fr);', Breakpoints.lx)};
`

export const AdvantagesElementStyled = styled(AdvantagesElement)`
	padding-right: 0;
	margin: 0;
`

export const TabStyled = styled(Tab)`
	margin-right: 0;
	width: 100%;
	${media('margin-right: 16px; width: initial;', Breakpoints.ms)};
`
